import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MaintenanceRecords from '@/components/maintenance/MaintenanceRecords';
import MaintenanceAnalytics from '@/components/maintenance/MaintenanceAnalytics';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import AddMaintenanceSheet from '@/components/contracts/AddMaintenanceSheet';

export default function Maintenance() {
  const [addMaintenanceOpen, setAddMaintenanceOpen] = useState(false);

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8 flex items-start justify-between">
        <div>
          <h1 className="text-4xl font-semibold tracking-tight mb-2">Maintenance</h1>
          <p className="text-muted-foreground">View vehicle maintenance history and service records.</p>
        </div>
        <Button onClick={() => setAddMaintenanceOpen(true)} className="gap-1.5">
          <Plus className="h-4 w-4" />
          Add Maintenance
        </Button>
      </div>

      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="records">Records</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics">
          <MaintenanceAnalytics />
        </TabsContent>

        <TabsContent value="records">
          <MaintenanceRecords />
        </TabsContent>
      </Tabs>

      <AddMaintenanceSheet
        open={addMaintenanceOpen}
        onOpenChange={setAddMaintenanceOpen}
      />
    </div>
  );
}
